const FEE_RATE = 0.02;

export function calculateProcessingFee(amount) {
  const numericAmount = parseFloat(amount);
  if (!numericAmount || numericAmount <= 0) return null;

  let totalCharge = Math.ceil((numericAmount / (1 - FEE_RATE)) * 100) / 100;
  let processorFee = Math.round(totalCharge * FEE_RATE * 100) / 100;
  let netAmount = totalCharge - processorFee;

  if (netAmount < numericAmount) {
    totalCharge = Math.round((totalCharge + 0.01) * 100) / 100;
    processorFee = Math.round(totalCharge * FEE_RATE * 100) / 100;
    netAmount = totalCharge - processorFee;
  }

  const feeAmount = Math.round((totalCharge - numericAmount) * 100) / 100;

  return {
    baseAmount: numericAmount,
    feePercent: FEE_RATE * 100,
    feeAmount,
    totalCharge,
  };
}
